import React, {Component} from 'react'
import {Button} from "reactstrap"
import AddNewModal from "./AddNewModal"

class AddNew extends Component {
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        const {isOpen} = this.state
        const {listPartner, listMaterial, listProductionMethods, listProductionProcess, list_catalog = []} = this.props || {}

        return (
            <div className="AddNew">
                <Button color='primary ml-3' onClick={this._handleToggleModal}>
                    Thêm mới
                </Button>
                {isOpen && (
                    <AddNewModal
                        isOpen={isOpen}
                        onToggleModal={this._handleToggleModal}
                        listPartner={listPartner}
                        listMaterial={listMaterial}
                        listProductionMethods={listProductionMethods}
                        listProductionProcess={listProductionProcess}
                        list_catalog={list_catalog}
                    />
                )}
            </div>
        )
    }

}

export default AddNew